import Ripple from '../../../lib/ripple';
export default Ripple;
